import { Store } from '@ngrx/store';
import { forkJoin } from 'rxjs';
import { getCategoryPageNum, getQueryInput, getSearchTypes, } from 'SearchApp/ts/apps/search-all-app/state/search-all.selectors';
import { SEARCH_ALL_METHODS } from 'SearchApp/ts/constants';
import { SearchService } from 'SearchApp/ts/services/search.service';
import equal from 'NewAngular/utils/equal/deep-equal';
import { changeSearchTypes, searchChangeCategoryPageNum, } from 'SearchAllApp/state/search-all-params/search-all-params.actions';
import * as i0 from "@angular/core";
import * as i1 from "SearchApp/ts/services/search.service";
import * as i2 from "@ngrx/store";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/components/pagination/simple-pagination-controls/simple-pagination-controls.component";
const _forTrack0 = ($index, $item) => $item.category;
const _forTrack1 = ($index, $item) => $item.id;
function SearchAllTableComponent_For_2_Conditional_5_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 9);
    i0.ɵɵlistener("click", function SearchAllTableComponent_For_2_Conditional_5_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r4); const searchResult_r2 = i0.ɵɵnextContext().$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.setCategorySearch(searchResult_r2.category)); });
    i0.ɵɵtext(1, "View All");
    i0.ɵɵelementEnd();
} }
function SearchAllTableComponent_For_2_For_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 8);
    i0.ɵɵelement(1, "div", 10);
    i0.ɵɵelementStart(2, "div", 11);
    i0.ɵɵtext(3);
    i0.ɵɵelementStart(4, "div", 12);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const entry_r5 = ctx.$implicit;
    i0.ɵɵproperty("href", entry_r5.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", entry_r5.display_security_id);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", entry_r5.name, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(entry_r5.desc);
} }
function SearchAllTableComponent_For_2_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelement(1, "div", 2);
    i0.ɵɵelementStart(2, "div", 3)(3, "div", 4)(4, "ycn-simple-pagination-controls", 5);
    i0.ɵɵlistener("pageChangeHandler", function SearchAllTableComponent_For_2_Template_ycn_simple_pagination_controls_pageChangeHandler_4_listener($event) { const searchResult_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.pageChanged($event, searchResult_r2.category)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵconditionalCreate(5, SearchAllTableComponent_For_2_Conditional_5_Template, 2, 0, "a", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 7);
    i0.ɵɵrepeaterCreate(7, SearchAllTableComponent_For_2_For_8_Template, 6, 4, "a", 8, _forTrack1);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const searchResult_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", searchResult_r2.label);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("paginationInfo", searchResult_r2.resultInfo.paginationInfo);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.perPage === 10 ? 5 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(searchResult_r2.resultInfo.results);
} }
function SearchAllTableComponent_Conditional_3_Conditional_5_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "or ");
    i0.ɵɵelementStart(2, "a", 13);
    i0.ɵɵlistener("click", function SearchAllTableComponent_Conditional_3_Conditional_5_Template_a_click_2_listener() { i0.ɵɵrestoreView(_r6); const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.resetSearchType()); });
    i0.ɵɵtext(3, "remove your search filter");
    i0.ɵɵelementEnd()();
    i0.ɵɵtext(4, ". ");
} }
function SearchAllTableComponent_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0)(1, "p");
    i0.ɵɵtext(2, "Sorry, there are no results which match that criteria.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p");
    i0.ɵɵtext(4, "Please try a different term ");
    i0.ɵɵconditionalCreate(5, SearchAllTableComponent_Conditional_3_Conditional_5_Template, 5, 0);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵconditional(!ctx_r2.allSearchTypeSelected ? 5 : -1);
} }
/**
 *
 * SearchAllTableComponent.
 *
 * This component is the table with search results. It has a link to get to specific results for a category.
 */
export class SearchAllTableComponent {
    constructor(searchService, store) {
        this.searchService = searchService;
        this.store = store;
        this.allSearchTypeSelected = false;
        this.perPage = 10; // when searching all categories is 10 but selecting "View All" for a category is 20
        this.queryInput = '';
        this.showError = false;
        this.resultHistory = {};
        this.searchMethodInfoList = [];
        this.searchMethodPagination = {};
        this.searchResultsList = [];
        this.searchTypes = [];
        this.mapStateToComponent = (state) => {
            const newSearchTypes = getSearchTypes(state);
            const newQueryInput = getQueryInput(state).toString();
            const newSearchMethodPagination = getCategoryPageNum(state);
            if ((!equal(this.searchTypes, newSearchTypes) && newSearchTypes.length > 1) ||
                this.queryInput !== newQueryInput) {
                this.perPage = 10;
            }
            this.searchTypes = newSearchTypes;
            this.searchMethodPagination = newSearchMethodPagination;
            this.queryInput = newQueryInput;
            this.searchMethodInfoList = SEARCH_ALL_METHODS.map((searchCategory) => ({
                ...searchCategory,
                page: this.searchMethodPagination[searchCategory.searchMethod] ?? 1,
            })).filter((searchCategory) => this.searchTypes.includes(searchCategory.searchMethod));
            this.allSearchTypeSelected =
                this.searchTypes.length === 0 || this.searchTypes.length === SEARCH_ALL_METHODS.length;
            const toFetch = [];
            this.searchMethodInfoList.forEach((search) => {
                // Check if we have the results for the current filters. If not, fetch a new object.
                const searchKey = this.getCurrentFiltersKey(search.searchMethod, search.page);
                if (!(searchKey in this.resultHistory) &&
                    this.searchTypes.length !== 0 &&
                    this.queryInput.trim().length !== 0) {
                    toFetch.push([search.searchMethod, search.page]);
                }
            });
            if (toFetch.length) {
                forkJoin(toFetch.map(([searchMethod, page]) => this.getSearchResults(searchMethod, page))).subscribe((responses) => {
                    responses.forEach((results, index) => {
                        this.resultHistory[this.getCurrentFiltersKey(toFetch[index][0], toFetch[index][1])] = results;
                    });
                    this.buildResultsList();
                });
            }
            else {
                this.buildResultsList();
            }
        };
        this.storeSubscription = this.store.select('reducers').subscribe(this.mapStateToComponent);
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }
    /**
     * Gets Search results using `searchType`, `queryInput`, `pageNum` and `perPage` as params.
     */
    getSearchResults(searchType, pageNum) {
        return this.searchService.getSearchAllResults(searchType, this.queryInput, pageNum, this.perPage);
    }
    buildResultsList() {
        this.searchResultsList = this.searchMethodInfoList
            .filter(({ searchMethod, page }) => {
            const searchKey = this.getCurrentFiltersKey(searchMethod, page);
            return this.resultHistory[searchKey] && this.resultHistory[searchKey].results.length;
        })
            .map(({ searchMethod: category, page, label }) => {
            const searchKey = this.getCurrentFiltersKey(category, page);
            const resultInfo = this.resultHistory[searchKey];
            return {
                category,
                label,
                resultInfo,
            };
        });
        this.showError = this.searchResultsList.length === 0;
    }
    /**
     * Resets the `searchType` filter setting all search types.
     */
    resetSearchType() {
        const searchTypes = SEARCH_ALL_METHODS.map((item) => item.searchMethod);
        this.store.dispatch(changeSearchTypes({ searchTypes }));
    }
    /**
     * Update page number of the search method.
     */
    pageChanged(pageNum, searchKey) {
        this.searchMethodPagination = {
            ...this.searchMethodPagination,
            [searchKey]: pageNum,
        };
        this.store.dispatch(searchChangeCategoryPageNum({ searchCategoryPageNum: this.searchMethodPagination }));
    }
    setCategorySearch(category) {
        this.perPage = 20;
        this.store.dispatch(changeSearchTypes({ searchTypes: [category] }));
    }
    /**
     * Returns a key for the results entry in `resultHistory`.
     */
    getCurrentFiltersKey(searchType, pageNum) {
        return `${searchType}-${this.queryInput}-${pageNum}-${this.perPage}`;
    }
}
SearchAllTableComponent.ɵfac = function SearchAllTableComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SearchAllTableComponent)(i0.ɵɵdirectiveInject(i1.SearchService), i0.ɵɵdirectiveInject(i2.Store)); };
SearchAllTableComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SearchAllTableComponent, selectors: [["ycn-search-all-table"]], standalone: false, decls: 4, vars: 1, consts: [[1, "search-all-results", "pt-3"], [1, "topic-section", "mb-3"], [1, "topic-title", "pb-12", 3, "textContent"], [1, "d-flex", "align-items-center", "justify-content-between", "pb-1"], [1, "panel-pagination"], [1, "panel-pagination-content", 3, "pageChangeHandler", "paginationInfo"], ["href", "javascript:void(0)", 1, "text-blue", "text-underline"], [1, "search-all-results-section"], [1, "search-all-results-link", "row", "no-gutters", 3, "href"], ["href", "javascript:void(0)", 1, "text-blue", "text-underline", 3, "click"], [1, "col-auto", "width-180", "text-bold", 3, "textContent"], [1, "col"], [1, "text-gray-50"], ["href", "javascript:void(0)", 3, "click"]], template: function SearchAllTableComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵrepeaterCreate(1, SearchAllTableComponent_For_2_Template, 9, 3, "div", 1, _forTrack0);
        i0.ɵɵelementEnd();
        i0.ɵɵconditionalCreate(3, SearchAllTableComponent_Conditional_3_Template, 6, 1, "div", 0);
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵrepeater(ctx.searchResultsList);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.showError ? 3 : -1);
    } }, dependencies: [i3.SimplePaginationControlsComponent], encapsulation: 2 });
